<table class="table col-md-6 mx-auto">
    <thead>
      <tr>
        <th>Name</th>
        <th>Value</th>
      </tr>
    </thead>
    <tbody *ngIf="keys">
      <tr *ngFor="let item of keys">
        <td>{{texts[item] || item}}</td>
        <td>{{calib[item]}}</td>
      </tr>
	</tbody>
</table>
